var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zlicon" },
    [
      _c("div", { staticClass: "account_set_header" }, [
        _c("h2", { style: { color: _vm.iconColor } }, [_vm._v("icon图标")]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "iconSet" },
          [
            _c("el-color-picker", {
              model: {
                value: _vm.iconColor,
                callback: function($$v) {
                  _vm.iconColor = $$v
                },
                expression: "iconColor"
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: { "font-size": "12px" },
                style: { color: _vm.iconColor }
              },
              [_vm._v("切换颜色试一试")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "30px" },
                style: { background: _vm.iconColor },
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function($event) {
                    _vm.dialogVisible = true
                  }
                }
              },
              [_vm._v("如何使用？")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "14px" } }, [
        _vm._v("\n    使用iconfont.js\n  ")
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "iconBox" },
        _vm._l(_vm.iconList, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              attrs: { title: item.icon },
              on: {
                click: function($event) {
                  return _vm.copyContent(item.icon)
                }
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon svg-icon",
                  staticStyle: {
                    width: "30px",
                    height: "30px",
                    "vertical-align": "-0.15em"
                  },
                  attrs: {
                    slot: "reference",
                    "aria-hidden": "true",
                    fill: _vm.iconColor
                  },
                  slot: "reference"
                },
                [_c("use", { attrs: { "xlink:href": "#" + item.icon } })]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "14px" } }, [
        _vm._v("\n    使用iconfont.css\n  ")
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "iconBox" },
        _vm._l(_vm.iconClassList, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              attrs: { title: item.icon },
              on: {
                click: function($event) {
                  return _vm.copyContent(item.icon)
                }
              }
            },
            [
              _c("span", {
                staticClass: "iconfont",
                class: item.icon,
                staticStyle: { "font-size": "30px" }
              })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "14px" } }, [
        _vm._v("\n    使用element/icon\n  ")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "有两种方法", visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticStyle: { margin: "10px 0" } }, [
            _vm._v(" 鼠标点击图标，即可复制class名称")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _vm._v("第一种：使用iconfont.js\n       "),
              _c("json-viewer", {
                staticStyle: { "line-height": "1.4" },
                attrs: {
                  value: _vm.iconCode,
                  copyable: "",
                  boxed: "",
                  sort: ""
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _vm._v("第二种：使用iconfont.css\n      "),
              _c("json-viewer", {
                staticStyle: { "line-height": "1.4" },
                attrs: {
                  value: _vm.iconStyle,
                  copyable: "",
                  boxed: "",
                  sort: ""
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v("注意复制后，要去掉引号！")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "iconBox" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://element.eleme.cn/#/zh-CN/component/icon",
              target: "_blank"
            }
          },
          [_vm._v("https://element.eleme.cn/#/zh-CN/component/icon")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-363d4dc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-363d4dc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/zlicon.vue
// module id = null
// module chunks = 